<div [ngClass]="['empty-container', containerClass]">
  <ng-content></ng-content>
  @if (showMessage) {
    <div class="empty-state">{{ message }}</div>
  }
</div>
